<template>
  	<main class="main" v-loading="loading">
  		<div class="price_banner">
  			<div class="w1200">
  				<img class="pic1" src="../assets/price/banner_ad.png">
	  			<h1>云资产已涵盖<br>科教、文化、贸易等诸多行业</h1>
  			</div>
  			<img class="pic2" src="../assets/price/banner_river.png">
  		</div>
  		<div class="w1000">
  			<h1 class="title"><img src="../assets/zhineng.png">云资产优惠套餐</h1>
  			<div class="line"></div>
  			<el-row :gutter="120" class="price_list">
			  <el-col :span="8">
			  	<div class="price-img" @click="routerTo">
			  	<img src="../assets/price/price1.png"></div>
			  </el-col>
			  <el-col :span="8">
			  	<div class="price-img" @click="routerTo">
			  	<img src="../assets/price/price6.png"></div>
			  </el-col>
			  <el-col :span="8">
			  	<div class="price-img" @click="routerTo">
			  	<img src="../assets/price/price2.png"></div>
			  </el-col>
			  <el-col :span="8">
			  	<div class="price-img" @click="routerTo">
			  	<img src="../assets/price/price3.png"></div>
			  </el-col>
			  <el-col :span="8">
			  	<div class="price-img" @click="routerTo">
			  	<img src="../assets/price/price4.png"></div>
			  </el-col>
			  <el-col :span="8">
			  	<div class="price-img" @click="routerTo">
			  	<img src="../assets/price/price5.png"></div>
			  </el-col>
			  
			</el-row>
  		</div>
  		<div class="price_yours">
  			<h2>没有合适方案？您可以联系我们，根据您的实际情况定制…</h2>
  			<button class="btn" @click="routerTo">联系我们</button>
  		</div>
  	</main>
</template>
<script>
export default {
  name: 'price',
  data () {
    return {
      loading:true
    }
  },
  methods:{
  	routerTo(){
      this.$router.push({ path: '/contact', query: { type: 4 }});
    }
  },
  mounted(){
	  this.loading=false
  }
}
</script>


// WEBPACK FOOTER //
// src/components/price.vue